import config from '../../config';

export default {
  install(Vue) {
    if (!Vue.Custom) Vue.Custom = {};
    Vue.Custom.config = config;
  },
};
